<template>
  <v-container v-if="auditPeriod">
    <v-app-bar app color="secondary" dark dense>
      <v-toolbar-title>
        {{
          $t("dashboard.oldAuditPeriod", {
            year: auditPeriod.year,
          })
        }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-chip v-if="auditPeriodIsClosed(auditPeriod)" color="green" dark>
        {{
          $t("dashboard.auditPeriod.closed", {
            date: new Date(auditPeriod.closedAt).toLocaleString(undefined, {
              timeZone: "CET",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            }),
          })
        }}
      </v-chip>
    </v-app-bar>

    <AuditPeriod :audit-period="auditPeriod" />
  </v-container>
</template>

<script>
import AuditPeriod from "@/components/User/AuditPeriod";
import AuditPeriodQuery from "@/gql/queries/AuditPeriodQuery.gql";
import auditPeriodIsClosed from "@fng/common/auditPeriodIsClosed";

export default {
  components: {
    AuditPeriod,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      auditPeriod: null,
    };
  },

  apollo: {
    auditPeriod: {
      query: AuditPeriodQuery,
      variables() {
        return {
          id: this.id,
        };
      },
    },
  },

  methods: {
    auditPeriodIsClosed,
  },

  mounted() {
    this.$vuetify.goTo(0);
  },
};
</script>
